import router from "../../router";

const strict = true;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async initialize({ commit, dispatch, rootGetters }) {
    commit("loading/openLoadingDialog", null, { root: true });
    let userInfo = rootGetters["login/userInfo"];
    let isConiuge = rootGetters["profile/getIsConiuge"];
    if (!userInfo.idIscritto) {
      router.push({ name: "login" });
      commit("loading/closeLoadingDialog", null, { root: true });
    } else {
      try {
        if (!isConiuge) {
          await dispatch("appointments/getNextAppointments", 2, {
            root: true
          });
          await dispatch("notifications/getNotificationsUnreadCount", null, {
            root: true
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        commit("loading/closeLoadingDialog", null, { root: true });
      }
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
